import React from "react";
import classNames from "classnames";
// @mui/icons-material
// import  from "@mui/icons-material/";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";

import commonStyles from "../home-page/HomeCommon.module.scss";

export default function SectionTeams({ ...rest }) {
  return (
    <div className="cd-section" {...rest}>

      {/* B2C Clients Start */}
      <div
      className={commonStyles.clientsSection}
        //className={commonStyles.team + " " + commonStyles.section}
        //style={{ backgroundImage: "url('/img/examples/city-sm.webp')" }}
        style={{ backgroundColor: "lightgrey"}}
      >
        <div className={commonStyles.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={
                classNames(commonStyles.mlAuto, commonStyles.mrAuto, commonStyles.textCenter)
              }
            >
              <h2 className={commonStyles.title}>Consumer (B2C) Clients</h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
          
            
              
                
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "10%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={24} md={24}>
                    <CardHeader image plain noShadow>
                      <a href="" >
                        <img
                          src="/img/clients/crg3-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "10%",paddingRight: "10%",paddingTop: "5%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/betfairlogo.png"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
           
            
           
            <GridItem xs={6} sm={3} md={3}>
              <Card profile plain className={commonStyles.card5} style={{paddingLeft: "20%",paddingRight: "20%",paddingTop: "0%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/mamma-knows-west-grey-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "15%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/midlandbrick-grey.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "10%",paddingRight: "10%",paddingTop: "35%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/prezzee-grey.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "20%",paddingRight: "20%",paddingTop: "25%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/rsd-grey.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>

            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "0%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/hbf-dental-logo-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>


            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "5%",paddingRight: "5%",paddingTop: "10%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/my-budget-logo-transparent-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>

            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "15%",paddingRight: "15%",paddingTop: "10%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/rb-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>


            
                  


            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "15%",paddingRight: "15%",paddingTop: "0%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/vitalcare-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>

          </GridContainer>
          
          
        </div>
        

        <br />
        {/* B2C Clients END */}
      </div>

      {/* B2B Clients Start */}
      <div
      className={commonStyles.clientsSection}
        //className={commonStyles.team + " " + commonStyles.section}
        //style={{ backgroundImage: "url('/img/examples/city-sm.webp')" }}
        style={{ backgroundColor: "white"}}
      >
        <div className={commonStyles.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={
                classNames(commonStyles.mlAuto, commonStyles.mrAuto, commonStyles.textCenter)
              }
            >
              <h2 className={commonStyles.title}>Business (B2B) Clients</h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
          
              
               
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "20%",paddingRight: "0%",paddingTop: "5%",paddingBottom: "0%"}}>
                
                <GridContainer>
                <GridItem xs={12} sm={8} md={8}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/PricewaterhouseCoopers-grey.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "5%",paddingRight: "5%",paddingTop: "25%",paddingBottom: "0%"}}>
                
                <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="https://www.bizcap.com.au" target="_blank">
                        <img
                          src="/img/clients/bizcap-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
              
              <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "5%",paddingBottom: "0%"}}>
                
                <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/steadfast-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
           
            <GridItem xs={6} sm={3} md={3}>
              <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "15%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="https://www.quallogi.com" target="_blank">
                        <img
                          src="/img/clients/quallogi-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "5%",paddingRight: "5%",paddingTop: "15%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/redwind-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "10%",paddingRight: "10%",paddingTop: "10%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/spenda-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
        
               

            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "20%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/ironmountain-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>

            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "20%",paddingRight: "20%",paddingTop: "25%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/isobar-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>

                </GridContainer>

              </Card>
            </GridItem>
          
          
          <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "10%",paddingRight: "10%",paddingTop: "0%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/makwater-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>

              </Card>
            </GridItem>

            </GridContainer>

        </div>

        <br />
        {/* B2B Clients END */}
      </div>

      {/* Other Clients Start */}
      <div
      className={commonStyles.clientsSection}
        //className={commonStyles.team + " " + commonStyles.section}
        //style={{ backgroundImage: "url('/img/examples/city-sm.webp')" }}
        style={{ backgroundColor: "lightgrey"}}
      >
        <div className={commonStyles.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={
                classNames(commonStyles.mlAuto, commonStyles.mrAuto, commonStyles.textCenter)
              }
            >
              <h2 className={commonStyles.title}>Other Clients</h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
          
            <GridItem xs={6} sm={3} md={3}>
              <Card profile plain className={commonStyles.card5} style={{paddingLeft: "20%",paddingRight: "20%",paddingTop: "5%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/afl-nsw-act-logo-grey.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "5%",paddingRight: "5%",paddingTop: "10%",paddingBottom: "10%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/hsm-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "10%",paddingRight: "10%",paddingTop: "10%",paddingBottom: "25%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/ilf-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "20%",paddingBottom: "20%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/mu-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
           
            <GridItem xs={6} sm={3} md={3}>
              <Card profile plain className={commonStyles.card5} style={{paddingLeft: "25%",paddingRight: "25%",paddingTop: "5%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/wilderness-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  
                </GridContainer>
              </Card>
            </GridItem>
            <GridItem xs={6} sm={3} md={3}>
            <Card profile plain className={commonStyles.card5} style={{paddingLeft: "0%",paddingRight: "0%",paddingTop: "0%",paddingBottom: "0%"}}>
                
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CardHeader image plain noShadow>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        <img
                          src="/img/clients/wwot-sm.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                
                </GridContainer>
              </Card>
            </GridItem>
            

          </GridContainer>
          
        </div>

        <br />
        {/* Other Clients END */}
      </div>

      
    </div>
  );
}
